import Config from '../Config';
import { RestService } from './RestService';

export const ItemService = {
    getItemList: async function(project_id){
        return RestService.get(`${Config.get_items}${project_id ? `project_id=${project_id}` : ''}`, {})
        .then(response => response.json());
    },
    create: async function(headers, body){
        return RestService.post(`${Config.create_item}`, headers, body);
        // .then(response => response.json());
    },
    remove: async function(headers, id){
        return RestService.post(`${Config.remove_item}id=${id}`, headers, {});
        // .then(response => response.json());
    }
};